module.exports = __webpack_public_path__ + "img/cover6.ca858806.jpg";